module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Custom Clearance Export Details")]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  })], 1), _vm._v(" "), _c('div', [_c('div', [_c('div', {
    staticClass: "row mt-3"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Search Client /SB No./Shipper Invoice No."
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.billingFilter),
      callback: function($$v) {
        _vm.billingFilter = $$v
      },
      expression: "billingFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.dateStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Date Filter"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('Normal', '0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.dateStatusFilter),
      callback: function($$v) {
        _vm.dateStatusFilter = $$v
      },
      expression: "dateStatusFilter"
    }
  })], 1), _vm._v(" "), _c('div', [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableMain table-responsive mt-4",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.AirImportData,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "seenExec",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ccImportSeries",
      fn: function(row1) {
        return [(row1.item.seenExec == '0') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("New\n                  "), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', {
          staticClass: "showMoreData",
          style: (row1.item.seenExec == '0' ? 'color:red' : 'color:black'),
          on: {
            "click": function($event) {
              row1.item.is_locked == '1' &&
                (row1.item.finalBillingCompleted == 1 ||
                  row1.item.locked_counter > 0) &&
                _vm.$sessionsStorage.get('designation') != 'Admin' &&
                _vm.$sessionsStorage.get('nameUser') != 'Bhavneesh' ?
                '' :
                _vm.viewExportAirPage(row1.item)
            }
          }
        }, [_vm._v(_vm._s(row1.item.ccImportSeries))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Assignment Dt.: " + _vm._s(_vm._f("moment")(row1.item.dateAssignment)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Raised From : " + _vm._s(row1.item.raisedFrom))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("By : " + _vm._s(row1.item.raisedBy))]), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.splitFromId != '0') ? _c('h7', {
          staticClass: "mt-2"
        }, [_c('b-badge', {
          attrs: {
            "variant": "info"
          }
        }, [_vm._v("Split of " + _vm._s(row1.item.splitFromNo)), _c('br')])], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row1.item.is_locked == '1' &&
              (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0) ?
              'danger' :
              'success'
          },
          on: {
            "click": function($event) {
              row1.item.is_locked == '1' &&
                (row1.item.finalBillingCompleted == 1 || row1.item.locked_counter > 0) ?
                _vm.LockUnLock(row1.item, 'locked') :
                ''
            }
          }
        }, [(
          row1.item.is_locked == '1' &&
          (row1.item.finalBillingCompleted == 1 ||
            row1.item.locked_counter > 0)
        ) ? _c('b', [_c('i', {
          staticClass: "fa fa-lock mr-1 lg"
        }), _vm._v("LOCKED")]) : _c('b', [_c('i', {
          staticClass: "fa fa-unlock mr-1 lg"
        }), _vm._v("UN-LOCKED")])]), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row1.item)
            }
          }
        }, [_vm._v("Summary & Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('Assignment-Summary', {
          attrs: {
            "title": 'Shipment Summary Tracking - ',
            "fk_all_module_id": row1.item.allModuleId,
            "jb_series": row1.item.ccImportSeries
          }
        }), _vm._v(" "), (row1.item.allModuleId) ? _c('ContainerSummary', {
          attrs: {
            "PMC_title": 'Container Summary Job No - ' + row1.item.ccImportSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.ccImportSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_AgentType": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), (row1.item.allModuleId) ? _c('RejectInvTallyBillSummary', {
          attrs: {
            "PMC_title": 'Invoice Rejection Log Summary Job No - ' + row1.item.ccImportSeries,
            "PMC_JOBID": row1.item.allModuleId,
            "PMC_JOBNO": row1.item.ccImportSeries,
            "PMC_JOBDATE": '',
            "PMC_JOBTYPE": '',
            "PMC_Client": '',
            "PMC_Sline": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('MSDeleteRequest', {
          attrs: {
            "item": row1.item,
            "JobNo": row1.item.ccImportSeries,
            "JobID": row1.item.allModuleId,
            "sessionsStorage": _vm.$sessionsStorage
          },
          on: {
            "refreshData": _vm.handleRefresh
          }
        }), _vm._v(" "), (row1.item.deleteRequestBy != '' && row1.item.deleteRequestBy != '0' && row1.item.deleteRequestBy != null) ? _c('b', [_vm._v("Requested By : " + _vm._s(row1.item.deleteRequestBy)), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.deleteArrovedBy != '' && row1.item.deleteArrovedBy != '0' && row1.item.deleteArrovedBy != null) ? _c('b', [_vm._v("Arroved By : " + _vm._s(row1.item.deleteArrovedBy)), _c('br')]) : _vm._e()]
      }
    }, {
      key: "Exporter",
      fn: function(row11) {
        return [_c('b', [_vm._v(" " + _vm._s(row11.item.Exporter))])]
      }
    }, {
      key: "POR",
      fn: function(row10) {
        return [_c('span', [_vm._v("Place of Receipt :- " + _vm._s(row10.item.POR))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Load Port :- " + _vm._s(row10.item.LP))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Port Of Discharge :- " + _vm._s(row10.item.POD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Final Place of Delivery :- " + _vm._s(row10.item.FPOD))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Booking No. :- " + _vm._s(row10.item.validBookingNo))]), _vm._v(" "), _c('br')]
      }
    }, {
      key: "newContainer",
      fn: function(row5) {
        return [(row5.item.newfreightContainers && row5.item.jobType.indexOf('FF') >= 0) ? _c('BookingTrack', {
          attrs: {
            "containerArr": row5.item.newfreightContainers,
            "slineName": '',
            "clientName": row5.item.Exporter,
            "modal_title": ("Container Movement Booking No: " + (row5.item.validBookingNo) + " Job No - " + (row5.item.ccImportSeries) + " Client: " + (row5.item.Exporter)),
            "JOBNO": row5.item.ccImportSeries,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(row5.item.allModuleId),
            "fk_booking_id": Number(row5.item.fk_booking_id),
            "fk_container_id": Number(0),
            "booking_number": row5.item.validBookingNo,
            "container_number": ''
          }
        }) : _vm._e(), _vm._v(" "), (row5.item.newContainerFlow == '1') ? _c('div', [(row5.item.newContainer) ? _c('div', _vm._l((row5.item.newContainer.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])], 1)])
        })) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]) : _c('div', [(row5.item.oldContainer) ? _c('div', _vm._l((row5.item.oldContainer.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1))])], 1)])
        })) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)])]
      }
    }, {
      key: "ffRailOutId",
      fn: function(row3) {
        return [(_vm.designation == 'superviser' && _vm.departmentName == 'Port/ICD') ? _c('b', {
          style: (row3.item.ffRailOutId == null || row3.item.ffRailOutId == '' ?
            {
              color: 'red'
            } :
            {
              color: 'green'
            })
        }, [_vm._v(_vm._s(row3.item.ffRailOutId == "" || row3.item.ffRailOutId == null ?
          "Pending" :
          "Completed"))]) : _vm._e()]
      }
    }, {
      key: "invoiceStatus",
      fn: function(row33) {
        return [_c('b', {
          style: (row33.item.invoiceStatus == '0' ?
            {
              color: 'green'
            } :
            {
              color: 'red'
            })
        }, [_vm._v(_vm._s(!row33.item.invoiceStatus ?
          "--" :
          row33.item.invoiceStatus == "1" ?
          "In-Progress" :
          row33.item.invoiceStatus == "0" ?
          "Sent To Accounts" :
          "--"))]), _vm._v(" "), (row33.item.sentForApproval && row33.item.sentForApproval == '1') ? _c('b', [_c('br'), _vm._v("\n                  Sent for Approval\n                ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '1'
        ) ? _c('b', [_c('br'), _vm._v("\n                  Was Sent for Approval and got Approved\n                ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '2'
        ) ? _c('b', [_c('br'), _vm._v("\n                  Was Sent for Approval and got Rejected\n                ")]) : _vm._e()]
      }
    }, {
      key: "show_details",
      fn: function(row) {
        return [_c('b-form-checkbox', {
          on: {
            "change": row.toggleDetails
          },
          model: {
            value: (row.detailsShowing),
            callback: function($$v) {
              _vm.$set(row, "detailsShowing", $$v)
            },
            expression: "row.detailsShowing"
          }
        }), _vm._v(" "), _c('Add-Message', {
          staticStyle: {
            "list-style-type": "none"
          },
          attrs: {
            "fk_all_module_id": row.item.allModuleId,
            "fk_client_id": row.item.clientId,
            "fk_pod_id": row.item.PODLocationId
          }
        }), _vm._v(" "), (row.item.jobType.indexOf('FF') < 0) ? _c('Overseas-CRDRNote', {
          attrs: {
            "title": row.item.ccImportSeries,
            "moduleType": 'CC ' + row.item.transportType + ' Module',
            "cr_all_module_id": row.item.allModuleId,
            "cr_jb_series": row.item.ccImportSeries,
            "cr_ass_date": _vm._f("moment")(row.item.dateAssignment),
            "transportType": row.item.transportType,
            "Jobtype": 'CC',
            "commonId": row.item.ccImportId,
            "shipmentType": row.item.shipmentType == '1' ||
              row.item.shipmentType == 'Sea_Shipment' ?
              'Sea' :
              'Air',
            "isOverseas": false,
            "ItemAr": null
          }
        }) : _vm._e()]
      }
    }, {
      key: "row-details",
      fn: function(row) {
        return [_c('b-card', [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.goToDoc(row.item.ccImportId)
            }
          }
        }, [_vm._v("View Documents")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_c('u', [_vm._v("Documentation Progress Summary")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Shipping Bill Date :\n                    " + _vm._s(row.item.shippingBillNo ? "Completed" : "Pending"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Leo Date : " + _vm._s(!row.item.leoDate ? "Pending" : "Completed"))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Handover Date :\n                    " + _vm._s(!row.item.handoverDate ? "Pending" : "Completed"))])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', [_c('h5', [_c('b-pagination', {
    attrs: {
      "limit": "5",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-lock-conf",
    attrs: {
      "id": "modal-lock-conf",
      "title": "Reason for Open Locked Assignment",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [_c('h3', [_vm._v("Confirmation")]), _vm._v(" "), _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Remark",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    model: {
      value: (_vm.lockReason),
      callback: function($$v) {
        _vm.lockReason = $$v
      },
      expression: "lockReason"
    }
  })], 1)], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeLockUnLockConfirm
    }
  }, [_vm._v(" Cancel")]), _vm._v(" "), (_vm.lockReason) ? _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "disabled": _vm.lock_button ? true : false,
      "variant": "success"
    },
    on: {
      "click": _vm.ConfLock
    }
  }, [_vm._v("Send")]) : _vm._e()], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35fd2b8a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/CCImport/viewCCExportDetail.vue
// module id = 2518
// module chunks = 0